import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FolderIcon } from 'components/event/FileSystem/FSObjectIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faRss } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { Dropdown, DropdownItem } from 'reactstrap';
import {
  StyledFontAwesome,
  StyledDropdownToggle,
  StyledDropdownMenu,
  FileUploadLabel,
  StyledMenuText,
  CustomFileInput
} from './CreateEventContentDropDown.styled';
import FileTypes from 'constants/FileTypes';

const fileInputId = 'createEventContent_fileUpload';

const CreateEventContentDropDown = ({ onBroadcastCreate, onFolderCreate }) => {
  const [isOpen, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(isOpen ? false : true), [isOpen]);

  return (
    <Dropdown
      className="d-none d-sm-block"
      isOpen={isOpen}
      toggle={e => {
        //In the case of file upload, we can't close the drop down until the user has selected files
        if (e.target.id === fileInputId) return;
        toggle();
      }}
    >
      <StyledDropdownToggle
        data-testid="createNewButton"
        color="primary"
        tag="div"
      >
        <Button data-testid="templateCreateNewButton" color="primary">
          Create new <StyledFontAwesome icon={faChevronDown} />
        </Button>
      </StyledDropdownToggle>
      <StyledDropdownMenu data-testid="createNewDropDown" flip={false}>
        <DropdownItem data-testid="studio" onClick={onBroadcastCreate}>
          <FontAwesomeIcon icon={faRss} color="red" />
          <StyledMenuText>Studio</StyledMenuText>
        </DropdownItem>
        <DropdownItem data-testid="folder" onClick={onFolderCreate}>
          <FolderIcon />
          <StyledMenuText>Folder</StyledMenuText>
        </DropdownItem>
      </StyledDropdownMenu>
    </Dropdown>
  );
};

function DocFileInput({ onChange }) {
  const validFileTypes = Object.values(FileTypes).join(', ');

  return (
    <>
      <FileUploadLabel className="" id={`${fileInputId}Label`}>
        File Upload
        <CustomFileInput
          data-testid={fileInputId}
          type="file"
          name="file"
          multiple
          aria-labelledby={`${fileInputId}Label`}
          id={fileInputId}
          onChange={onChange}
          accept={validFileTypes}
        />
      </FileUploadLabel>
    </>
  );
}

CreateEventContentDropDown.propTypes = {
  onBroadcastCreate: PropTypes.func.isRequired,
  onFolderCreate: PropTypes.func.isRequired,
  team: PropTypes.object
};

DocFileInput.propTypes = {
  onChange: PropTypes.func
};

export default CreateEventContentDropDown;
